import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import { useNavigate } from 'react-router-dom';

export function NotesMarkdown({ text, className = '' }) {
  const navigate = useNavigate();
  if (!text) return null;
  const components = {
    a: ({ href, children }) => {
      if (href && href.startsWith('/')) {
        return (
          <a href={href} data-testid="ai-deal-link"
            className="text-violet-300 font-medium underline decoration-violet-500/50 underline-offset-2 hover:text-violet-200 cursor-pointer"
            onClick={(e) => { e.preventDefault(); navigate(href); }}>
            {children}
          </a>
        );
      }
      return <a href={href} target="_blank" rel="noreferrer" className="text-blue-400 underline underline-offset-2">{children}</a>;
    },
  };
  return (
    <div className={`notes-markdown ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkBreaks]} components={components}>{text}</ReactMarkdown>
    </div>
  );
}
